export default __webpack_public_path__ + "static/dionysus-logo-bigger-6ffeefa72f598bcb1c9274dbcfa91b81.png";